/* import requests from "./httpService";
import getEmployeeId from "utils/commonAdmin";


const VendorServices = {
  getAllVendor: async (body) => {
    // const id_employee =await getEmployeeId(); 
    // return requests.get(`/vendor/list/${id_employee}`);
    return requests.get(`vendor/list`);
  },

  getAllVendorRequest: async (body) => {
    return requests.get(`/vendorrequest`);
  },

  addVendor: async (body) => {
    // const id_employee =await getEmployeeId(); 
    // return requests.post(`/vendor/add/${id_employee}`, body);
    return requests.post(`/vendor/add`, body);
  },

  getVendorById: async (id) => {
    return requests.get(`vendor/${id}`);
  },

  updateVendor: async (id, body) => {
    // const id_employee =await getEmployeeId(); 
    // return requests.put(`/vendor/update/${id}/${id_employee}`, body);
    return requests.put(`/vendor/update/${id}`, body);
  },

  deleteVendor: async (id) => {
    // const id_employee =await getEmployeeId(); 
    // return requests.put(`/vendor/delete/${id}/${id_employee}`);
    return requests.put(`vendor/delete/${id}`);
  },


  vendorApproveReject:async(id)=>{
    return requests.put(`vendor/status/${id}`)
  },


  updateVendorStatus: async (id, body) => {
    const id_employee =await getEmployeeId(); 
    return requests.put(`/vendor/activeInactive/${id}/${id_employee}`, body);
  },

  getAllReferenceNo: async (id, body) => {
    return requests.get(`/vendor/company-name`, body);
  },

  updateVendorBlockStatus: async (id, body) => {
    const id_employee =await getEmployeeId(); 
    return requests.put(`/vendor/blockStatus/${id}/${id_employee}`, body);
  },
   getRemarksById: async (id) => {
    return requests.get(`/vendor/getStatusRemarksById/${id}`);
  },
};

export default VendorServices;
 */








import requests from "./httpService";
import getEmployeeId from "utils/commonAdmin";


const VendorServices = {
  getAllVendor: async (type) => {
    return requests.get(`vendor/list?type=${type}`);
  },

  getAllVendorRequest: async () => {
    return requests.get(`/vendorrequest`);
  },

  addVendor: async (body) => {
    return requests.post(`/vendor/add`, body);
  },

  getVendorById: async (id) => {
    return requests.get(`vendor/${id}`);
  },

  updateVendor: async (id, body) => {
    return requests.put(`/vendor/update/${id}`, body);
  },

  deleteVendor: async (id) => {
    return requests.put(`vendor/delete/${id}`);
  },


  vendorApproveReject: async (id, body) => {
    return requests.put(`vendor/status/${id}`, body)
  },

  //toggle Vendor Status
  updateVendorStatus: async (id, body) => {
    return requests.put(`/vendor/manage-status/${id}`, body);
  },

  getAllReferenceNo: async (id, body) => {
    return requests.get(`/vendor/company-name`, body);
  },

  updateVendorBlockStatus: async (id, body) => {
    const id_employee = await getEmployeeId();
    return requests.put(`/vendor/blockStatus/${id}/${id_employee}`, body);
  },
  getRemarksById: async (id) => {
    return requests.get(`/vendor/getStatusRemarksById/${id}`);
  },
};

export default VendorServices;
